import { UserEmailMinNotificationLevel } from 'dy-frontend-http-repository/lib/data/enums';

const userEmailNotificationLevelInformation: {
    [level in UserEmailMinNotificationLevel]: {
        name: string;
        description: string;
    };
} = {
    [UserEmailMinNotificationLevel.HIGH]: {
        name: 'All',
        description: 'User will get all email notifications',
    },
    [UserEmailMinNotificationLevel.NORMAL]: {
        name: 'Balanced',
        description: "We'll only send notifications which require user's action",
    },
    [UserEmailMinNotificationLevel.LOW]: {
        name: 'Only important',
        description: 'User will only get critical notifications related to their requests',
    },
    [UserEmailMinNotificationLevel.OFF]: {
        name: 'No email notifications',
        description: "We'll not send any notifications",
    },
};

export default userEmailNotificationLevelInformation;
